import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eBusPhanTuyenActionTypeIds, IBusPhanTuyenActionTypes } from "../../action-types/bus/IBusPhanTuyenActionTypes";
import { IBusPhanTuyenPageStateModel } from "../../page-state-model/bus/IBusPhanTuyenPageState";

const initialState: IBusPhanTuyenPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	bus_phantuyens: [],
	bus_tuyenduong_chitiets: [],
	bus_diemdontras: [],
	bus_loaidiemdons: [],
	bus_tuyenduong_chitiet_editing: undefined,
	is_show_tuyenduong_chitiet_modal: false,
	bus_tuyenduong_chitiet_deleting: undefined,
	is_show_delete_tuyenduong_chitiet_confirm: false,
	is_show_add_hocsinh_modal: false,
	add_hocsinh_bus_tuyenduong_id: 0,
	add_hocsinh_bus_diemdontra_id: 0,
	hocsinh_chuaphantuyen_status: ePageBaseStatus.is_not_initialization,
	hocsinh_chuaphantuyens: [],
	hocsinh_chuaphantuyen_selected_ids: [],
	hocsinh_deleting: undefined,
	is_show_delete_hocsinh_confirm: false,
	is_show_import_chitiet_modal: false,
	import_bus_tuyenduong_id: 0,
	import_status: ePageBaseStatus.is_not_initialization,
	import_validated_datas: []
}

export const busPhanTuyenReducer = (state: IBusPhanTuyenPageStateModel = initialState, action: IBusPhanTuyenActionTypes): IBusPhanTuyenPageStateModel => {
	switch (action.type) {
		case eBusPhanTuyenActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eBusPhanTuyenActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_phantuyens: action.payload
			}
		case eBusPhanTuyenActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_phantuyens: []
			}
		case eBusPhanTuyenActionTypeIds.LOAD_TUYENDUONG_CHITIET_START:
			return {
				...state
			}
		case eBusPhanTuyenActionTypeIds.LOAD_TUYENDUONG_CHITIET_SUCCESS:
			return {
				...state,
				bus_tuyenduong_chitiets: action.payload
			}
		case eBusPhanTuyenActionTypeIds.LOAD_TUYENDUONG_CHITIET_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_tuyenduong_chitiets: []
			}
		case eBusPhanTuyenActionTypeIds.LOAD_DIEMDONTRA_START:
			return {
				...state
			}
		case eBusPhanTuyenActionTypeIds.LOAD_DIEMDONTRA_SUCCESS:
			return {
				...state,
				bus_diemdontras: action.payload
			}
		case eBusPhanTuyenActionTypeIds.LOAD_DIEMDONTRA_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_diemdontras: []
			}
		case eBusPhanTuyenActionTypeIds.LOAD_LOAIDIEMDON_START:
			return {
				...state
			}
		case eBusPhanTuyenActionTypeIds.LOAD_LOAIDIEMDON_SUCCESS:
			return {
				...state,
				bus_loaidiemdons: action.payload
			}
		case eBusPhanTuyenActionTypeIds.LOAD_LOAIDIEMDON_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_loaidiemdons: []
			}
		case eBusPhanTuyenActionTypeIds.SHOW_TUYENDUONG_CHITIET_DETAIL:
			return {
				...state,
				is_show_tuyenduong_chitiet_modal: true,
				bus_tuyenduong_chitiet_editing: action.payload
			}
		case eBusPhanTuyenActionTypeIds.CLOSE_TUYENDUONG_CHITIET_DETAIL:
			return {
				...state,
				is_show_tuyenduong_chitiet_modal: false,
				bus_tuyenduong_chitiet_editing: undefined
			}
		case eBusPhanTuyenActionTypeIds.SAVE_TUYENDUONG_CHITIET_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eBusPhanTuyenActionTypeIds.SAVE_TUYENDUONG_CHITIET_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật tuyến chi tiết thành công" : "Thêm tuyến chi tiết thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_tuyenduong_chitiet_modal: false,
				bus_tuyenduong_chitiet_editing: undefined
			}
		case eBusPhanTuyenActionTypeIds.SAVE_TUYENDUONG_CHITIET_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eBusPhanTuyenActionTypeIds.SHOW_DELETE_TUYENDUONG_CHITIET_CONFIRM:
			return {
				...state,
				is_show_delete_tuyenduong_chitiet_confirm: true,
				bus_tuyenduong_chitiet_deleting: action.payload
			}
		case eBusPhanTuyenActionTypeIds.CLOSE_DELETE_TUYENDUONG_CHITIET_CONFIRM:
			return {
				...state,
				is_show_delete_tuyenduong_chitiet_confirm: false,
				bus_tuyenduong_chitiet_deleting: undefined
			}
		case eBusPhanTuyenActionTypeIds.DELETE_TUYENDUONG_CHITIET_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eBusPhanTuyenActionTypeIds.DELETE_TUYENDUONG_CHITIET_SUCCESS:
			NotifyHelper.Success("Xóa tuyến chi tiết thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_tuyenduong_chitiet_confirm: false,
				bus_tuyenduong_chitiet_deleting: undefined
			}
		case eBusPhanTuyenActionTypeIds.DELETE_TUYENDUONG_CHITIET_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_tuyenduong_chitiet_confirm: false
			}
		case eBusPhanTuyenActionTypeIds.SHOW_ADD_HOCSINH_MODAL:
			return {
				...state,
				is_show_add_hocsinh_modal: true,
				add_hocsinh_bus_tuyenduong_id: action.payload.bus_tuyenduong_id,
				add_hocsinh_bus_diemdontra_id: action.payload.bus_diemdontra_id,
				hocsinh_chuaphantuyens: [],
				hocsinh_chuaphantuyen_selected_ids: [],
				hocsinh_chuaphantuyen_status: ePageBaseStatus.is_not_initialization
			}
		case eBusPhanTuyenActionTypeIds.CLOSE_ADD_HOCSINH_MODAL:
			return {
				...state,
				is_show_add_hocsinh_modal: false,
				add_hocsinh_bus_tuyenduong_id: 0,
				add_hocsinh_bus_diemdontra_id: 0,
				hocsinh_chuaphantuyens: [],
				hocsinh_chuaphantuyen_selected_ids: [],
				hocsinh_chuaphantuyen_status: ePageBaseStatus.is_not_initialization
			}
		case eBusPhanTuyenActionTypeIds.LOAD_HOCSINH_CHUAPHANTUYEN_START:
			return {
				...state,
				hocsinh_chuaphantuyen_status: ePageBaseStatus.is_loading,
				hocsinh_chuaphantuyen_selected_ids: []
			}
		case eBusPhanTuyenActionTypeIds.LOAD_HOCSINH_CHUAPHANTUYEN_SUCCESS:
			return {
				...state,
				hocsinh_chuaphantuyen_status: ePageBaseStatus.is_completed,
				hocsinh_chuaphantuyens: action.payload
			}
		case eBusPhanTuyenActionTypeIds.LOAD_HOCSINH_CHUAPHANTUYEN_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				hocsinh_chuaphantuyen_status: ePageBaseStatus.is_completed,
				hocsinh_chuaphantuyens: []
			}
		case eBusPhanTuyenActionTypeIds.CHANGE_HOCSINH_CHUAPHANTUYEN_SELECTED_IDS:
			return {
				...state,
				hocsinh_chuaphantuyen_selected_ids: action.payload
			}
		case eBusPhanTuyenActionTypeIds.SAVE_PHANTUYEN_HOCSINH_START:
			return {
				...state,
				hocsinh_chuaphantuyen_status: ePageBaseStatus.is_saving
			}
		case eBusPhanTuyenActionTypeIds.SAVE_PHANTUYEN_HOCSINH_SUCCESS:
			NotifyHelper.Success("Phân tuyến thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				hocsinh_chuaphantuyen_status: ePageBaseStatus.is_completed,
				is_show_add_hocsinh_modal: false,
				add_hocsinh_bus_tuyenduong_id: 0,
				add_hocsinh_bus_diemdontra_id: 0,
				hocsinh_chuaphantuyens: [],
				hocsinh_chuaphantuyen_selected_ids: []
			}
		case eBusPhanTuyenActionTypeIds.SAVE_PHANTUYEN_HOCSINH_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				hocsinh_chuaphantuyen_status: ePageBaseStatus.is_completed
			}
		case eBusPhanTuyenActionTypeIds.SHOW_DELETE_HOCSINH_CONFIRM:
			return {
				...state,
				is_show_delete_hocsinh_confirm: true,
				hocsinh_deleting: action.payload
			}
		case eBusPhanTuyenActionTypeIds.CLOSE_DELETE_HOCSINH_CONFIRM:
			return {
				...state,
				is_show_delete_hocsinh_confirm: false,
				hocsinh_deleting: undefined
			}
		case eBusPhanTuyenActionTypeIds.DELETE_HOCSINH_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eBusPhanTuyenActionTypeIds.DELETE_HOCSINH_SUCCESS:
			NotifyHelper.Success("Thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_hocsinh_confirm: false,
				hocsinh_deleting: undefined
			}
		case eBusPhanTuyenActionTypeIds.DELETE_HOCSINH_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_hocsinh_confirm: false
			}
		case eBusPhanTuyenActionTypeIds.SHOW_IMPORT_CHITIET_MODAL:
			return {
				...state,
				is_show_import_chitiet_modal: true,
				import_bus_tuyenduong_id: action.payload,
				import_status: ePageBaseStatus.is_not_initialization,
				import_validated_datas: []
			}
		case eBusPhanTuyenActionTypeIds.CLOSE_IMPORT_CHITIET_MODAL:
			return {
				...state,
				is_show_import_chitiet_modal: false,
				import_bus_tuyenduong_id: 0,
				import_status: ePageBaseStatus.is_not_initialization,
				import_validated_datas: []
			}
		case eBusPhanTuyenActionTypeIds.VALIDATE_IMPORT_CHITIET_START:
			return {
				...state,
				import_status: ePageBaseStatus.is_loading
			}
		case eBusPhanTuyenActionTypeIds.VALIDATE_IMPORT_CHITIET_SUCCESS:
			return {
				...state,
				import_status: ePageBaseStatus.is_completed,
				import_validated_datas: action.payload || []
			}
		case eBusPhanTuyenActionTypeIds.VALIDATE_IMPORT_CHITIET_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				import_status: ePageBaseStatus.is_completed,
				import_validated_datas: []
			}
		case eBusPhanTuyenActionTypeIds.IMPORT_CHITIET_START:
			return {
				...state,
				import_status: ePageBaseStatus.is_saving
			}
		case eBusPhanTuyenActionTypeIds.IMPORT_CHITIET_SUCCESS:
			NotifyHelper.Success("Import tuyến đường thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				import_status: ePageBaseStatus.is_completed,
				is_show_import_chitiet_modal: false,
				import_bus_tuyenduong_id: 0,
				import_validated_datas: []
			}
		case eBusPhanTuyenActionTypeIds.IMPORT_CHITIET_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				import_status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
